// author: lx zhangmyh
// latest: zhangmyh 2017-3-29 5:29 PM
// 部门人员参照
import Collection from 'common/vo/collection'
import 'collection/person'
import 'collection/department'
import { Post, URLs } from 'common'
/* global $ u */

let _config
async function init (refer) {
  const loadTreeNoDept = async function (tree) {
    let treeData = await Post(URLs.ea_getDept.url, {
      enterpriseId: enterpriseId,
      parentId: _config.parentId
    })
    let { result } = treeData
    let newdata = []
    result.forEach(function (orginfo) {
      if (parseInt(orginfo.orgType) <= 1) {
        newdata.push(orginfo)
      }
    })
    tree.load({}, { localData: { result: newdata } })
  }

  // 树形控件加载有误,所以需要每次都重新加载
  let collection = Collection.create('collection.person')
  let tree = Collection.create('collection.department')
  let enterpriseId = refer.options.enterpriseId || window.global.user.enterpriseId
  // debugger
  let selectedNode = {}
  let selectedData = []
  let selectflag = false
  if (_config.canExpand) {
    tree.load({ enterpriseId: enterpriseId, parentId: _config.parentId })
  } else {
    loadTreeNoDept(tree)
  }

  let vm = {
    treemodel: tree.datatable,
    treeOption: {
      callback: {
        beforeClick: async function (id, obj) {
          if (!obj.flag) {
            if (_config.canExpand) {
              let { result } = await Post(URLs.ea_getDept.url, {
                enterpriseId: enterpriseId,
                parentId: obj.id
              })
              tree.datatable.addSimpleData(result)
            }
            obj.flag = true
          }
          selectedNode = obj
          collection.datatable.removeAllRows()
          collection.load({
            organizationid: obj.id,
            pageIndex: 0,
            pageSize: 10
          })
        }
      }
    },
    config: {
      id: 'gridperson',
      data: collection,
      type: 'grid',
      multiSelect: _config.multiSelect,
      editable: false,
      pagination: true,
      fields: [{
        field: 'personname',
        dataType: 'String',
        title: '人员',
        width: '50%'
      }, {
        field: 'personcode',
        dataType: 'String',
        title: '编码',
        width: '50%'
      }]
    }
  }

  let app = u.createApp()
  app.init(vm, $('#refer_orgperson')[0])
  refer.registerSubmitFunc(() => {
    return selectedData
  })

  collection.on('data', function (result) {
    if (_config.multiSelect && !_config.repeatable && refer.options.defaultData) {
      if (selectedData.length <= 0) {
        // 初始化默认值
        let defaultData = refer.options.defaultData()
        if (defaultData instanceof Array) {
          selectedData = defaultData
        }
      }

      let SelectIndex = []
      result.data.result.forEach(function (listItem, i) {
        selectedData.forEach(function (item) {
          if (item.id === listItem.id) {
            SelectIndex.push(i)
          }
        })
      })
      collection.datatable.setRowsSelect(SelectIndex)
    }
    selectflag = true
  })

  collection.datatable.on('unSelect', function (obj) {
    let selectData = collection.datatable.getRowByRowId(obj.rowIds[0])
    let index = -1
    selectedData.forEach(function (item, i) {
      if (item.id === selectData.getValue('id')) {
        index = i
      }
    })
    if (index >= 0) {
      selectedData.splice(index, 1)
    }
  })

  collection.datatable.on('select', function (obj) {
    if (!_config.multiSelect) {
      let selectData = collection.datatable.getCurrentRow().data
      selectedData = {
        id: selectData.id.value,
        name: selectData.personname.value,
        code: selectData.personcode.value,
        enterpriseId: window.global.user.enterpriseId,
        enterpriseName: window.global.user.enterpriseName,
        // psnId: selectData.id.value,
        // psnName: selectData.personname.value,
        // psnCode: selectData.personcode.value,
        userId: selectData.userid.value,
        userName: selectData.username.value,
        moblie: selectData.moblie.value,
        deptId: selectData.organizationid.value,
        deptName: selectedNode.name
      }
      refer.submit()
      return
    }
    // 默认初始化已选择数据的时候不触发数据改变
    if (selectflag) {
      let selectData = collection.datatable.getRowByRowId(obj.rowIds[obj.rowIds.length - 1]).data
      selectedData.push({
        id: selectData.id.value,
        name: selectData.personname.value,
        code: selectData.personcode.value,
        enterpriseId: window.global.user.enterpriseId,
        enterpriseName: window.global.user.enterpriseName,
        userId: selectData.userid.value,
        userName: selectData.username.value,
        moblie: selectData.moblie.value,
        deptId: selectData.organizationid.value,
        deptName: selectedNode.name
      })
    }
  })
}

let template = require('./index.html')
export default function (config) {
  _config = Object.assign({
    parentId: 0,
    canExpand: true,
    multiSelect: false,
    repeatable: false
  }, config)

  return {
    init,
    template
  }
}



// WEBPACK FOOTER //
// ./src/components/modalrefer/orgPerson/index.js